import type { ReactElement } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { ApiError } from '@/lib/api/api-error';

function describe(error: unknown): string {
  if (isRouteErrorResponse(error)) {
    return `${String(error.status)} ${error.statusText}`;
  }
  if (error instanceof ApiError) {
    return error.status === null ? 'No connection to the server' : error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return 'Something went wrong';
}

export function RouteError(): ReactElement {
  const error = useRouteError();

  return (
    <main className="flex min-h-dvh items-center justify-center p-gutter">
      <div className="w-full max-w-md rounded-card border border-line bg-surface-raised p-8 shadow-card">
        <h1 className="text-lg font-semibold">This page could not load</h1>
        <p className="mt-2 text-sm text-fg-muted">{describe(error)}</p>
        <button
          type="button"
          className="mt-6 rounded-control bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700"
          onClick={() => {
            window.location.reload();
          }}
        >
          Try again
        </button>
      </div>
    </main>
  );
}
